import React from 'react';
import { EmptyIcon } from './EmptyIcon';
import './index.scss';
import { useIntl } from 'react-intl';
import { translationWithErrorHandling } from '../../../../../../../translation/handleMissingTranslation';

export const EmptyListView = () => {
	const intl = useIntl();
	return (
		<div className="emptyListWrapper">
			<EmptyIcon />
			<span className="emptyListText">
				{translationWithErrorHandling(intl, 'emptyListView.noAccess')}
			</span>
		</div>
	);
};
